import {
  Form,
  Select,
  Upload,
  Button,
  message,
  Table,
  Popconfirm,
  Drawer,
  Space,
  Input,
  Image
} from "antd";

import { UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import api from "../../services/api";

export default function SubCategoryColorImages() {

  const [subcategories,setSubcategories] = useState([]);
  const [colors,setColors] = useState([]);
  const [records,setRecords] = useState([]);

  const [drawerOpen,setDrawerOpen] = useState(false);
  const [editing,setEditing] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [form] = Form.useForm();

  useEffect(()=>{
    loadSubcategories();
    loadColors();
    loadRecords();
  },[]);

  /* ---------------- LOAD DATA ---------------- */

  const loadSubcategories = async()=>{
    const res = await api.get("/catalog/subcategories");
    setSubcategories(res.data || []);
  };

  const loadColors = async()=>{
    const res = await api.get("/attributes");

    const colorAttr = res.data.find(a=>a.name==="Colors");

    setColors(colorAttr?.AttributeValues || []);
  };

  const loadRecords = async()=>{
    const res = await api.get("/catalog/subcategory-color-images");
    setRecords(res.data || []);
  };

  /* ---------------- CREATE / UPDATE ---------------- */

  const handleSubmit = async (values) => {

    try {

      const formData = new FormData();

      // 🔥 NEW FILES
      values.images?.forEach(file => {
      if (file.originFileObj) {
        formData.append("images", file.originFileObj);
      }
      });

      // 🔥 EXISTING IDS
      const existingIds = values.images
      ?.filter(file => !file.originFileObj)
      ?.map(file => file.id);

      formData.append("existing_ids", JSON.stringify(existingIds));

      // other fields
      formData.append("subcategory_id", values.subcategory_id);
      formData.append("color_id", values.color_id);

      if (editing) {

        // 🔥 UPDATE API
        await api.put(
          `/catalog/subcategory-color-images/${editing.id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );

        message.success("Image updated");

      } else {

        await api.post(
          "/catalog/subcategory-color-images",
          formData
        );

        message.success("Images uploaded");
      }

      form.resetFields();
      setDrawerOpen(false);
      setEditing(null);

      loadRecords();

    } catch (err) {

      message.error(
        err.response?.data?.message || "Operation failed"
      );

    }
  };

  /* ---------------- EDIT ---------------- */

  const handleEdit = (record) => {

    setEditing(record);

    form.setFieldsValue({
      subcategory_id: record.subcategory_id,
      color_id: record.color_id,

      images: record.images?.map((img, index) => ({
        uid: index,
        id:img.id,
        name: "images",
        status: "done",
        url: `${process.env.REACT_APP_API_URL}${img.image_url}`
      }))
    });

    setDrawerOpen(true);
  };

  /* ---------------- DELETE ---------------- */

  const handleDelete = async(id)=>{

    await api.delete(`/catalog/subcategory-color-images/${id}`);

    message.success("Deleted");

    loadRecords();
  };

  const filteredRecords = records.filter((r) => {
    const subName = r.subcategory?.name?.toLowerCase() || "";
    const colorName = r.color?.value?.toLowerCase() || "";
    const search = searchText.toLowerCase();

    return (
      subName.includes(search) ||
      colorName.includes(search)
    );
  });
  /* ---------------- TABLE ---------------- */

  const columns = [

    {
      title:"SubCategory",
      render:(_,r)=>r.subcategory?.name
    },

    {
      title:"Color",
      render:(_,r)=>r.color?.value
    },

    {
      title:"Image",
      render: (_, r) => (
        r.images?.map(img => (
          <Image
            key={img.id}
            width={50}
            src= {`${process.env.REACT_APP_API_URL}${img.image_url}`}
          />
        ))
      )
    },

    {
      title:"Action",
      render:(_,r)=>(
        <Space>

          <Button
            onClick={()=>handleEdit(r)}
          >
            Edit
          </Button>

          <Popconfirm
            title="Delete image?"
            onConfirm={()=>handleDelete(r.id)}
          >
            <Button danger>
              Delete
            </Button>
          </Popconfirm>

        </Space>
      )
    }

  ];

  /* ---------------- UI ---------------- */

  return(

    <>

      <Button
        type="primary"
        onClick={()=>{
          setEditing(null);
          form.resetFields();
          setDrawerOpen(true);
        }}
      >
        Add Image
      </Button>
        <Input.Search
          placeholder="Search SubCategory / Color..."
          style={{ width: 300, marginLeft: 15 }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      <Table
        rowKey="id"
        dataSource={filteredRecords}
        columns={columns}
        style={{marginTop:20}}
      />

      {/* ---------------- DRAWER ---------------- */}

      <Drawer
        title={editing?"Edit Image":"Add Image"}
        open={drawerOpen}
        onClose={()=>setDrawerOpen(false)}
      >

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >

          <Form.Item
            name="subcategory_id"
            label="SubCategory"
            rules={[{required:true}]}
          >
            <Select
              options={subcategories.map(s=>({
                value:s.id,
                label:s.name
              }))}
            />
          </Form.Item>

          <Form.Item
            name="color_id"
            label="Color"
            rules={[{required:true}]}
          >
            <Select
              options={colors.map(c=>({
                value:c.id,
                label:c.value
              }))}
            />
          </Form.Item>

          <Form.Item
            name="images"
            label="Images"
            valuePropName="fileList"
            getValueFromEvent={(e)=>e?.fileList}
          >
            <Upload
                beforeUpload={()=>false}
                listType="picture"
                multiple= {true}   
                maxCount={10}
                onRemove={async (file)=>{
                  if (editing) {
                    await api.put(`/catalog/subcategory-color-images/${editing.id}/remove-image`);
                    message.success("Image removed");
                  }
                }}
              >
              <Button icon={<UploadOutlined/>}>
                Upload Images
              </Button>
            </Upload>
          </Form.Item>

          <Button type="primary" htmlType="submit">
            Save
          </Button>

        </Form>

      </Drawer>

    </>

  );

}